/*
 * Stardog error codes, as they appear in the `code` field of an error response
 * body. Only the ones Studio reacts to are listed.
 */
export const STARDOG_ERROR_CODES = {
  // InvalidDatabaseStateException. Raised when a database is asked to enter the
  // state it is already in, in either direction.
  INVALID_DATABASE_STATE: '0DIDS2',
};
